import { useMemo } from 'react'
import { useRouter } from 'next/router'
import qs from 'qs'
import getFirstQueryString from '@/utils/getFirstQueryString'

export default function useCouponLink () {
  const router = useRouter()
  const { service, broadcastId, ...rest } = router.query || {}
  return useMemo(
    () => {
      const queries = qs.stringify(rest)
      const serviceId = getFirstQueryString(service)
      const _broadcastId = getFirstQueryString(broadcastId)
      return _broadcastId && serviceId
        ? `/${encodeURIComponent(serviceId)}/live/${encodeURIComponent(_broadcastId)}/coupon${queries ? `?${queries}` : ''}`
        : ''
    },
    [broadcastId, service, rest]
  )
}
